import RichText, { type RichTextProps } from './RichText';

export type OrcRichTextProps = RichTextProps;

export default function OrcRichText(props: OrcRichTextProps) {
  return <RichText {...props} />;
}
